import React, { useState, useRef } from "react";
import { Popover as initialPopover, Icon } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import ApplyFilterModal from "./ApplyFilterModal";
import { isFilterApplied } from "../../utils";
import StyledChip from "../../../../../components/styled/Chip";

const Popover = styled(initialPopover).attrs()`
  overflow: visible;
  .eui-option-inner:hover {
    background-color: ${(props) => props.theme.palette.light.c100};
  }
  .eui-option-child {
    font-weight: 400 !important;
    display: flex !important;
    .trigger {
      width: 100%;
    }
  }
`;

const Filter = ({
  initialColumns,
  applyFilter,
  currencyCode = "INR",
  chipProps = {},
  isFilterDisabled: initialFilterDisabled = false,
  selectedFilterIndex,
  title,
  type,
}) => {
  const [selected, setSelected] = useState(false);
  const columns = [...initialColumns];
  const renderFilterList = () => (
    <div>
      {columns.map((column, index) =>
        column.filter ? (
          <Popover.Options key={index}>
            <Popover
              content={
                <>
                  <ApplyFilterModal
                    columns={columns}
                    index={index}
                    applyFilter={applyFilter}
                    showClear={false}
                    title={title}
                    type={type}
                  />
                </>
              }
              offset={[0, 25]}
              placement="left"
              trigger="click"
              width={360}
            >
              {column.label == "Value of Code"
                ? `${column.label} (${currencyCode})`
                : column.label}{" "}
            </Popover>
          </Popover.Options>
        ) : (
          ""
        )
      )}
    </div>
  );
  const isFilterSelected = isFilterApplied(columns);
  const isFilterDisabled =
    (initialFilterDisabled && !isFilterSelected) || selectedFilterIndex > -1;
  const isFilterAvailable =
    columns.filter((column) => column.filter).length > 0;
  return isFilterAvailable ? (
    <div>
      <Popover
        onVisibilityChange={(data) => {
          setSelected(data);
        }}
        content={isFilterDisabled ? null : renderFilterList()}
        offset={[0, 16]}
        placement="bottom-end"
        width={isFilterDisabled ? 0 : 252}
      >
        <StyledChip
          {...chipProps[selected ? "active" : "unactive"]}
          label="Filters"
          textColor={"dark"}
          textShade={"c300"}
          size="medium"
          disabled={isFilterDisabled}
          className={`ml-24 px-12`}
          id="reports-filter-btn"
          isFilterSelected={isFilterSelected}
          avatar={
            <div className="pl-2">
              <Icon
                iconName="Filter"
                className="mt-6"
                color={"dark"}
                shade={"c300"}
                size={16}
              />
            </div>
          }
        />
      </Popover>
    </div>
  ) : null;
};

export default Filter;
